//Sends stripe token to server upon form submission
function stripeTokenHandler(token) {
  var form = document.getElementById('payment-form');
  var hiddenInput = document.createElement('input');
  hiddenInput.setAttribute('type', 'hidden');
  hiddenInput.setAttribute('name', 'stripeToken');
  hiddenInput.setAttribute('value', token.id);
  form.appendChild(hiddenInput);

  form.submit();
}

//Adds stripe element to form, responds to error and submit events
function stripeHandler(stripePublicKey) {
  var form = document.getElementById('payment-form');
  var button = document.getElementById('payment-button');
  button.disabled = true;

  var stripe = Stripe(stripePublicKey);
  var elements = stripe.elements();
  var style = {
    base: {
      color: '#32325f',
      // lineHeight: '24px',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  };

  var card = elements.create('card', { style });
  card.mount('#card-element');

  // Handle real-time validation errors from the card Element.
  card.addEventListener('change', function (event) {
    var displayError = document.getElementById('card-errors');
    if (event.error) {
      displayError.textContent = event.error.message;
      button.disabled = true;
    } else {
      displayError.textContent = '';
      event.empty ? button.disabled = true : button.disabled = false;
    }
  });

  // Handle form submission
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    //Check if form has already been successfully submitted 
    // to prevent multiple submissions
    if (!form.classList.contains('submitted')) {
      // Form set as submitted
      form.classList.add('submitted');
      stripe.createToken(card).then(function (result) {
        if (result.error) {
          // Inform the user if there was an error
          var errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
          // Remove submitted class to allow resubmission
          form.classList.remove('submitted');
        } else {
          // Send the token to your server
          stripeTokenHandler(result.token);
        }
      });
    };
  });
}

module.exports = stripeHandler;


// WEBPACK FOOTER //
// ./public/src/stripeHandler.js